import { IFacet } from '../../models/IFacet';
import { ICheckboxGroup } from '../../models/checkbox-group/ICheckboxGroup';
import { IOption } from '../../models/checkbox/IOption';

export function mapFacetsToFilters(
  allFacets: IFacet[],
  selectedFacets: IFacet[],
): ICheckboxGroup[] {
  const filters = allFacets.map(
    (facet): ICheckboxGroup => ({
      name: facet.title,
      id: facet.id,
      options: facet.values.map(
        (facetTerm): IOption => ({
          text: facetTerm,
          name: facetTerm,
          parentName: facet.id,
          id: facetTerm,
          selected: !!selectedFacets.find((selectedFacet) =>
            selectedFacet.values.includes(`"${facetTerm}"`),
          ),
        }),
      ),
    }),
  );
  return filters;
}
